export const GEMINI_VOICES = [
  { id: "Puck", name: "Puck", description: "Upbeat", gender: "Male" },
  { id: "Charon", name: "Charon", description: "Informative", gender: "Male" },
  { id: "Kore", name: "Kore", description: "Firm", gender: "Female" },
  { id: "Fenrir", name: "Fenrir", description: "Excitable", gender: "Male" },
  { id: "Aoede", name: "Aoede", description: "Breezy", gender: "Female" },
  { id: "Achernar", name: "Achernar", description: "Soft", gender: "Female" },
  { id: "Achird", name: "Achird", description: "Friendly", gender: "Male" },
  { id: "Algenib", name: "Algenib", description: "Gravelly", gender: "Male" },
  { id: "Algieba", name: "Algieba", description: "Smooth", gender: "Male" },
  { id: "Alnilam", name: "Alnilam", description: "Firm", gender: "Male" },
  { id: "Autonoe", name: "Autonoe", description: "Bright", gender: "Female" },
  { id: "Callirrhoe", name: "Callirrhoe", description: "Easy-going", gender: "Female" },
  { id: "Despina", name: "Despina", description: "Smooth", gender: "Female" },
  { id: "Enceladus", name: "Enceladus", description: "Breathy", gender: "Male" },
  { id: "Erinome", name: "Erinome", description: "Clear", gender: "Female" },
  { id: "Gacrux", name: "Gacrux", description: "Mature", gender: "Female" },
  { id: "Iapetus", name: "Iapetus", description: "Clear", gender: "Male" },
  { id: "Laomedeia", name: "Laomedeia", description: "Upbeat", gender: "Female" },
  { id: "Leda", name: "Leda", description: "Youthful", gender: "Female" },
  { id: "Orus", name: "Orus", description: "Firm", gender: "Male" },
  { id: "Pulcherrima", name: "Pulcherrima", description: "Forward", gender: "Female" },
  { id: "Rasalgethi", name: "Rasalgethi", description: "Informative", gender: "Male" },
  { id: "Sadachbia", name: "Sadachbia", description: "Lively", gender: "Male" },
  { id: "Sadaltager", name: "Sadaltager", description: "Knowledgeable", gender: "Male" },
  { id: "Schedar", name: "Schedar", description: "Even", gender: "Male" },
  { id: "Sulafat", name: "Sulafat", description: "Warm", gender: "Female" },
  { id: "Umbriel", name: "Umbriel", description: "Easy-going", gender: "Male" },
  { id: "Vindemiatrix", name: "Vindemiatrix", description: "Gentle", gender: "Female" },
  { id: "Zephyr", name: "Zephyr", description: "Bright", gender: "Female" },
  { id: "Zubenelgenubi", name: "Zubenelgenubi", description: "Casual", gender: "Male" },
] as const;

export type GeminiVoice = typeof GEMINI_VOICES[number]["id"];

export const OPENAI_REALTIME_VOICES = [
  { id: "alloy", name: "Alloy" },
  { id: "ash", name: "Ash" },
  { id: "ballad", name: "Ballad" },
  { id: "coral", name: "Coral" },
  { id: "echo", name: "Echo" },
  { id: "sage", name: "Sage" },
  { id: "shimmer", name: "Shimmer" },
  { id: "verse", name: "Verse" },
  { id: "marin", name: "Marin" },
  { id: "cedar", name: "Cedar" },
] as const;

export type OpenAIRealtimeVoice = typeof OPENAI_REALTIME_VOICES[number]["id"];

export function isOpenAIRealtimeVoice(value: string | null): value is OpenAIRealtimeVoice {
  return OPENAI_REALTIME_VOICES.some((voice) => voice.id === value);
}
